import Link from 'next/link';
import { type FC } from 'react';

import { GenericMenuItem } from '@craft/ui/components/lists';

import type * as types from './types';

import { Pages } from '@/src/config/pages';

import { useIsNavButtonSelected } from './useIsNavButtonSelected';

export const MobileSideNavButton: FC<types.ISideNavButton> = props => {
  const isSelected = useIsNavButtonSelected(props);

  const href = props.page ? Pages.constructPath(props.page, {}) : props.href;

  return (
    <GenericMenuItem
      aria-current={isSelected ? 'page' : undefined}
      aria-label={`go to ${props.children.toLowerCase()} page`}
      component={props.isExternal ? 'a' : Link}
      data-attr-selected={isSelected}
      gap='24px'
      href={href}
      icon={props.icon}
      iconProps={{ color: 'secondary.main' }}
      id={props.children.toLowerCase().replace(' ', '-')}
      isSelectable
      isSelected={isSelected}
      rel={props.isExternal ? 'noopener noreferrer' : undefined}
      selectionModes={['background', 'font-weight']}
      sx={{ borderRadius: '0.5rem', paddingX: 2 }}
      target={props.isExternal ? '_blank' : undefined}
      title={props.children}
      titleProps={{
        color: isSelected ? 'secondary' : 'text.secondary',
        fontSize: '1.125rem',
      }}
    />
  );
};
